export default __webpack_public_path__ + "static/media/logo-inverted.677edd69.png";